import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Container, Nav, NavItem, Row, NavLink, TabContent, TabPane, Form, Label, Input, FormFeedback } from "reactstrap";
import classnames from "classnames";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useParams } from 'react-router-dom';
import { useCommonDataFindAllQuery, usePoolFindAllQuery, usePoolUpdateMutation } from "store";
import MainMap from "Components/MainMap/Index";
import voyager from '../../../assets/images/map/voyager.png';
import google from '../../../assets/images/map/google.jpg';
import topo from '../../../assets/images/map/topo.jpg';
import openstreet from '../../../assets/images/map/openstreet.jpg';
import Measurement from "./Measurement";
import OwnerIndex from "Components/Owner/Index";
import Labrator from "./Labrator";
import UsageIndex from "Components/Usage/Index";
import SafetyIndex from "Components/Safety/Index";
import ShapeUpload from "Components/fileUpload/ShapeUpload";
import Switch from "react-switch";
import Flatpickr from "react-flatpickr";

const ConstPoolAndPondShow = () => {

  const { id } = useParams();

  const [activeTab, setactiveTab] = useState("1");
  const [baseMap, setBaseMap] = useState("google")
  const { data, error, isFetching } = usePoolFindAllQuery(`/${id}`);
  const [poolMainData, setPoolMainData] = useState<any>();
  const [poolGeom, setPoolGeom] = useState<any>();
  const [customCenter, setCustomCenter] = useState<any>();
  const [poolUpdate, poolUpdateResult] = usePoolUpdateMutation();
  const [saveBorder, setSaveBorder] = useState<boolean>(false);

  const [resetFiles, setResetFiles] = useState<boolean>(false);
  const [selectedFiles, setSelectedFiles] = useState<any>([]);

  const {
    data: costBudget,
    error: costBudgetError,
    isFetching: isCommonBudgetFetching,
  } = useCommonDataFindAllQuery(`?group_name=cmn_invesetment_source`);

  const {
    data: commonPool,
    error: commonPoolError,
    isFetching: isCommonPoolFetching,
  } = useCommonDataFindAllQuery(`?group_name=cmn_pool_type`);

  useEffect(() => {
    setPoolMainData(data?.data)
    setPoolGeom(poolMainData?.geom)
    const tempCenter = { cusCenter: poolGeom?.coordinates };
    setCustomCenter(tempCenter);

    const tempSaveBorder = poolMainData !== null ? poolMainData?.save_border : false;
    setSaveBorder(tempSaveBorder)

  }, [poolGeom, poolMainData, data])

  const toggle = (tab: any) => {
    if (activeTab !== tab) {
      setactiveTab(tab);
    }
  };


  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      id: poolMainData?.id,
      code: poolMainData?.code,
      name: poolMainData?.name,
      cmn_invesetment_source: poolMainData?.cmn_invesetment_source,
      cmn_pool_type: poolMainData?.cmn_pool_type,
      location: poolMainData?.location,
      used_date: poolMainData?.used_date,
      built_organization_description: poolMainData?.built_organization_description,
      budget_cost: poolMainData?.budget_cost,
      save_border_desicion: poolMainData?.save_border_desicion,

      au1_name: poolMainData?.au1_name,
      au2_name: poolMainData?.au2_name,
      au3_name: poolMainData?.au3_name,

    },
    validationSchema: Yup.object({
      code: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      name: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      budget_cost: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      cmn_invesetment_source: Yup.string().typeError("Утга сонгоно уу").required("Утга оруулна уу !"),
      cmn_pool_type: Yup.string().typeError("Утга сонгоно уу").required("Утга оруулна уу !"),
      save_border_desicion: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      used_date: Yup.date().typeError("Он сар өдөр оруулна уу").required("Утга оруулна уу !"),
      built_organization_description: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      location: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
    }),
    onSubmit: (values: any) => {
      const formData = new FormData();
      formData.append('id', poolMainData ? poolMainData.id.toString() : '0');
      formData.append('code', values?.code);
      formData.append('name', values?.name);
      formData.append('cmn_invesetment_source', values?.cmn_invesetment_source);
      formData.append('cmn_pool_type', values?.cmn_pool_type);
      formData.append('location', values?.location);
      formData.append('used_date', values?.used_date);
      formData.append('save_border_desicion', values?.save_border_desicion);
      formData.append('save_border', String(saveBorder ?? false));
      formData.append('built_organization_description', values?.built_organization_description);
      formData.append('budget_cost', values?.budget_cost);

      if (selectedFiles && selectedFiles.length > 0) {
        selectedFiles.forEach((file: File, index: number) => {
          formData.append(`shapes`, file);
        });
      }
      poolUpdate(formData);
      validation.resetForm();
      setResetFiles(true);
    },
  });

  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Үгүй
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Тийм
      </div>
    );
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody>

                  <Nav tabs>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "1",
                        })}
                        onClick={() => {
                          toggle("1");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                        <span className="d-none d-sm-block">Үндсэн бүртгэл</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "2",
                        })}
                        onClick={() => {
                          toggle("2");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="far fa-user"></i></span>
                        <span className="d-none d-sm-block">Хэмжилт</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "3",
                        })}
                        onClick={() => {
                          toggle("3");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="far fa-envelope"></i></span>
                        <span className="d-none d-sm-block">Шинжилгээ</span>
                      </NavLink>
                    </NavItem>

                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "4",
                        })}
                        onClick={() => {
                          toggle("4");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="fas fa-cog"></i></span>
                        <span className="d-none d-sm-block">Ашиглалт</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "5",
                        })}
                        onClick={() => {
                          toggle("5");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="fas fa-cog"></i></span>
                        <span className="d-none d-sm-block">Хамгаалалт</span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "6",
                        })}
                        onClick={() => {
                          toggle("6");
                        }}
                      >
                        <span className="d-block d-sm-none"><i className="fas fa-cog"></i></span>
                        <span className="d-none d-sm-block">Эзэмшигч</span>
                      </NavLink>
                    </NavItem>
                  </Nav>

                  <TabContent activeTab={activeTab} className="px-3 pt-3 text-muted">
                    <TabPane tabId="1">
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col lg={4}>
                            <div className="mb-3">
                              <Label className="text-danger">Хөв цөөрмийн бүртгэлийн дугаар  *</Label>
                              <Input
                                name="code"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.code || ""}
                                invalid={
                                  validation.touched.code &&
                                    validation.errors.code
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.code &&
                                validation.errors.code ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.code}
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <Label className="text-danger">Гүйцэтгэсэн компани *</Label>
                              <Input
                                name="built_organization_description"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.built_organization_description || ""}
                                invalid={
                                  validation.touched.built_organization_description && validation.errors.built_organization_description
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.built_organization_description && validation.errors.built_organization_description ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.built_organization_description}
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <Label className="text-danger">Хөв цөөрмийн байршил *</Label>
                              <Input
                                name="location"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.location || ""}
                                invalid={
                                  validation.touched.location && validation.errors.location
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.location && validation.errors.location ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.location}
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <Label >Баг, хороо</Label>
                              <Input
                                disabled
                                name="au3_name"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.au3_name || ""}
                                invalid={
                                  validation.touched.au3_name && validation.errors.au3_name
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.au3_name && validation.errors.au3_name ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.au3_name}
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <Label>Сум, дүүрэг</Label>
                              <Input
                                disabled
                                name="au2_name"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.au2_name || ""}
                                invalid={
                                  validation.touched.au2_name && validation.errors.au2_name
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.au2_name && validation.errors.au2_name ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.au2_name}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div className="mb-3">
                              <Label className="text-danger">	Хөрөнгө оруулалтын төрөл *</Label>
                              <Input
                                name="cmn_invesetment_source"
                                type="select"
                                className="form-select"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.cmn_invesetment_source || ""}
                                invalid={
                                  validation.touched.cmn_invesetment_source &&
                                    validation.errors.cmn_invesetment_source
                                    ? true
                                    : false
                                }
                              >
                                <option disabled value="">Сонгох</option>
                                {costBudget?.data?.map((item, index) => (
                                  <option value={item?.id}>{item?.name}</option>
                                ))}

                              </Input>
                              {validation.touched.cmn_invesetment_source &&
                                validation.errors.cmn_invesetment_source ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.cmn_invesetment_source}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label className="text-danger">	Хөв цөөрмийн төрөл *</Label>
                              <Input
                                name="cmn_pool_type"
                                type="select"
                                className="form-select"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.cmn_pool_type || ""}
                                invalid={
                                  validation.touched.cmn_pool_type &&
                                    validation.errors.cmn_pool_type
                                    ? true
                                    : false
                                }
                              >
                                <option disabled value="">Сонгох</option>
                                {commonPool?.data?.map((item, index) => (
                                  <option value={item?.id}>{item?.name}</option>
                                ))}

                              </Input>
                              {validation.touched.cmn_pool_type &&
                                validation.errors.cmn_pool_type ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.cmn_pool_type}
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <Label className="text-danger">Нийт төсөв  *</Label>
                              <Input
                                name="budget_cost"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.budget_cost || ""}
                                invalid={
                                  validation.touched.budget_cost && validation.errors.budget_cost
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.budget_cost && validation.errors.budget_cost ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.budget_cost}
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <Label >Аймаг, нийслэл</Label>
                              <Input
                                name="au1_name"
                                disabled
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.au1_name || ""}
                                invalid={
                                  validation.touched.au1_name && validation.errors.au1_name
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.au1_name && validation.errors.au1_name ? (
                                <FormFeedback status="invalid">
                                  {validation.errors.au1_name}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div className="mb-3">
                              <Label className="text-danger">Хөв цөөрмийн нэр *</Label>
                              <Input
                                name="name"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.name || ""}
                                invalid={
                                  validation.touched.name && validation.errors.name
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.name && validation.errors.name ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.name}
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <Label className="text-danger">Хамгаалалтын бүстэй эсэх*</Label> <br />
                              <Switch
                                uncheckedIcon={<Offsymbol />}
                                checkedIcon={<OnSymbol />}
                                className="me-1 mb-sm-8 mb-2 ms-3"
                                onColor="#626ed4"
                                onChange={() => {
                                  setSaveBorder(!saveBorder);
                                }}
                                checked={saveBorder}
                              />
                            </div>
                            <div className="mb-3">
                              <Label className="text-danger">Хамгаалалтын бүсийн шийдвэр *</Label>

                              <Input
                                name="save_border_desicion"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.save_border_desicion || ""}
                                invalid={
                                  validation.touched.save_border_desicion && validation.errors.save_border_desicion
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.save_border_desicion && validation.errors.save_border_desicion ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.save_border_desicion}
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <Label className="text-danger">Ашиглалт орсон огноо *</Label>
                              <Flatpickr
                                className="form-control d-block"
                                placeholder="Огноо"
                                name="used_date"
                                value={validation.values.used_date}
                                onChange={(selectDate: Date[]) => {
                                  if (selectDate[0]) {
                                    const localDate = new Date(selectDate[0].getTime() - selectDate[0].getTimezoneOffset() * 60000)
                                      .toISOString()
                                      .split('T')[0];
                                    validation.setFieldValue('used_date', localDate);
                                  }
                                }}
                                options={{
                                  altInput: true,
                                  altFormat: "Y-m-d",
                                  dateFormat: "Y-m-d",
                                  enableTime: false,
                                }}
                              />
                              {validation.touched.used_date && validation.errors.used_date ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.used_date}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </Col>

                          <ShapeUpload selectFiles={setSelectedFiles} onReset={resetFiles} />
                        </Row>
                        <Row>
                          <Col lg={12}>
                            <div className='mapTypeSelection'>
                              <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('voyager') }} src={voyager} alt="" />
                              <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('google') }} src={google} alt="" />
                              <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('topo') }} src={topo} alt="" />
                              <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('openstreet') }} src={openstreet} alt="" />
                            </div>
                            <MainMap baseMap={baseMap} results={poolGeom} customCenter={customCenter} zoomChange={15} type={'point'} />
                          </Col>
                        </Row>

                        <Row>
                          <Col lg={12} className="d-flex justify-content-center mt-3">
                            <button type="submit" className="btn btn-primary"> Хадгалах </button>
                          </Col>
                        </Row>
                      </Form>

                    </TabPane>
                    <TabPane tabId="2">
                      <Measurement />
                    </TabPane>
                    <TabPane tabId="3">
                      <Labrator />
                    </TabPane>
                    <TabPane tabId="4">
                      <UsageIndex id={id} table_name={'pool'} />
                    </TabPane>
                    <TabPane tabId="5">
                      <SafetyIndex id={id} table_name={'pool'} />
                    </TabPane>
                    <TabPane tabId="6">
                      <OwnerIndex id={id} table_name={'pool'} />
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>


          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ConstPoolAndPondShow;